import { SxProps } from "@mui/material";
import { Suspense, useEffect, useRef, type ComponentType, type LazyExoticComponent } from "react";
import type { FieldValues } from "react-hook-form";
import { useFormContext } from "react-hook-form";

export function AutoSubmitSelectInput(props: {
  source: string;
  label: string;
  submit: (formData: { [k: string]: any }) => void;
  sx?: SxProps;
  InputComponent:
    | ComponentType<{ source: string; label: string; disabled?: boolean }>
    | LazyExoticComponent<ComponentType<{ source: string; label: string; disabled?: boolean; sx?: SxProps }>>;
}) {
  const { source, label, submit, sx, InputComponent, ...inputProps } = props;
  const { watch } = useFormContext<FieldValues>();

  const currentValue = watch(source) as string | undefined;
  const initialValueRef = useRef(currentValue);
  const hasSubmittedRef = useRef(false);

  useEffect(() => {
    if (hasSubmittedRef.current) {
      return;
    }
    if (currentValue && currentValue !== initialValueRef.current) {
      hasSubmittedRef.current = true;
      submit({ [source]: currentValue });
    }
  }, [currentValue, source, submit]);

  return (
    <Suspense fallback={null}>
      <InputComponent source={source} label={label} {...inputProps} sx={sx} />
    </Suspense>
  );
}
